<div
  class="search-input search-input--has-focus"
  [class.search-input--has-focus]="hasFocus"
  [class.search-input--has-value]="searchControl.value"
  [class.search-input--has-chips]="hasChips && withChips"
  [class.search-input--hide-chips-indicator]="moreChipsCount <= 0"
  #container
  cdkMonitorSubtreeFocus
  (cdkFocusChange)="onSubtreeFocusChange($event)"
>
  <ul class="search-input__chips" *ngIf="withChips" #chipsContainer>
    <li
      class="search-input__chip"
      #chip
      *ngFor="let region of activeRegions; let i = index; trackBy: trackBy"
    >
      <lib-removable-chip
        class="search-input-chip"
        (click)="onChipClick()"
        (remove)="removeRegionFilter(region)"
      >
        {{ region.name }}
      </lib-removable-chip>
    </li>
  </ul>

  <div
    class="search-input__more-chips-indicator"
    #moreChipsIndicator
    (click)="onMoreChipsClick()"
  >
    +{{ moreChipsCount }}
  </div>

  <div class="search-input__field" #field>
    <label class="search-input__label" for="search-input-field">
      {{ placeholderText | i18n }}
    </label>

    <input
      class="search-input__input"
      type="search"
      id="search-input-field"
      autocomplete="search"
      #input
      [formControl]="searchControl"
      (keydown.escape)="onEscape()"
      (keydown.enter)="onEnter()"
      (keydown.backspace)="onBackspace()"
      (focus)="onFocus()"
    />
  </div>
</div>
